module.exports = __webpack_public_path__ + "static/media/q.89ded3de.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/q.mp3
// module id = 106
// module chunks = 0